import React from "react";
import "../../styles/Footer.css";

export default function Footer() {
  return (
    <div style={{ textAlign: "center" }}>
      <h4
        id="powered-by"
        style={{
          color: "#2C2E34",
          fontFamily: "Poppins",
          fontSize: "15px",
        }}
      >
        Powered by
        <span style={{ color: "#3A3D45", fontFamily: "Poppins" }}> va</span>
        <span style={{ color: "#1796FF", fontFamily: "Poppins" }}>énable</span>
      </h4>
    </div>
  );
}